import type { IOffersDataLayer } from '@/types/DataLayer'

export const useOffersDataLayer = () => {
  function pushOffersDataLayer(data: IOffersDataLayer) {
    pushToDataLayer({
      event: 'header_events',
      generic_event_name: 'notification_icon',
      ...data
    })
  }

  return {
    pushOffersDataLayer
  }
}
